import React from 'react'
import { OverlayFillUi } from './ui/overlay-fill-ui'
import { OverlayUi } from './ui/overlay-ui'

interface OverlayProps {
  hide?: () => void
  dark?: boolean
  zIndex?: number | string
}

export const Overlay = ({ dark = false, zIndex = 1, hide }: OverlayProps) => (
  <OverlayUi onClick={hide} dark={dark} zIndex={zIndex}>
    <OverlayFillUi />
  </OverlayUi>
)
